import {OrderStatus} from '@yandex-taxi/js-integration-api'

export const activeOrderStatuses: string[] = [
  OrderStatus.SEARCH,
  OrderStatus.TRANSPORTING,
  OrderStatus.DRIVING,
  OrderStatus.WAITING,
  OrderStatus.SCHEDULING,
]
